// sessiongConstants.js
// Handling specific constant values we will use in our session validation hooks and around the application

export const SESSION_CHECK_INTERVAL_MS = 1000 * 60 * 5; // 5 minutes
export const IDLE_GRACE_MS = 1000 * 60 * 15; // 15 minutes
